import { useEffect } from 'react';
const useOnEscapeKey = onEscape => {
  useEffect(() => {
    const handleKeyDown = e => {
      if (e.key === 'Escape') onEscape();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onEscape]);
};
export default useOnEscapeKey;